import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DiscountRejectionCouponExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { AppearanceFormGroup } from '../../../model';
import {
  widgetTypeRadioOptions,
  widgetAppearanceFields,
  buttonFields,
} from '../../../discount-rejection-coupon.config';

@Component({
  selector: 'discount-rejection-coupon-appearance',
  templateUrl: './discount-rejection-coupon-appearance.component.html',
  styleUrls: ['./discount-rejection-coupon-appearance.component.scss'],
  standalone: false,
})
export class DiscountRejectionCouponAppearanceComponent {
  @Input() appearanceFormGroup: FormGroup<AppearanceFormGroup>;
  @Input() isClickableDisabled: boolean = false;

  WidgetType = DiscountRejectionCouponExtension.WidgetType;
  widgetTypeRadioOptions = widgetTypeRadioOptions;
  widgetAppearanceFields = widgetAppearanceFields;
  buttonFields = buttonFields;
}
